import { INpsScore } from './types';

export const SCORES: Array<INpsScore> = [
  { value: 0, color: '#8f1710', mood: 'sad' },
  { value: 1, color: '#a91d15', mood: 'sad' },
  { value: 2, color: '#c1281d', mood: 'sad' },
  { value: 3, color: '#d43a2f', mood: 'sad' },
  { value: 4, color: '#e05146', mood: 'sad' },
  { value: 5, color: '#e96a60', mood: 'sad' },
  { value: 6, color: '#ef857c', mood: 'sad' },
  { value: 7, color: '#d9a40a', mood: 'flat' },
  { value: 8, color: '#efc42a', mood: 'flat' },
  { value: 9, color: '#57b45d', mood: 'happy' },
  { value: 10, color: '#2f9b47', mood: 'happy' },
];

export const PROMOTER_MIN_SCORE = 9;

export const isPromoterScore = (score: number): boolean => score >= PROMOTER_MIN_SCORE;
